<template>
  <div class="section-separator" :class="{ 'reverse': reverse }">
    <div class="separator-content">
      <div class="separator-line left"></div>
      <div class="separator-emblem">
        <div class="emblem-outer">
          <div class="emblem-dot left"></div>
          <div class="emblem-dot right"></div>
        </div>
        <div class="emblem-inner">
          <div class="emblem-icon"></div>
        </div>
      </div>
      <div class="separator-line right"></div>
    </div>
    <div class="separator-triangles">
      <div class="triangle-left"></div>
      <div class="triangle-right"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionSeparator',
  props: {
    reverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.section-separator {
  position: relative;
  width: 100%;
  margin-top: -70px;
  height: 80px; /* Reduced from 120px for better fit */
  z-index: 0;
  pointer-events: none;
  overflow: visible;
}

.section-separator.reverse {
  transform: rotate(180deg);
  margin-top: 30px;
  margin-bottom: -60px;
}

.separator-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.separator-line {
  height: 3px;
  background: linear-gradient(90deg, transparent, #8f0000, rgba(183, 185, 186, 0.8));
  width: 25%;
  max-width: 300px;
  position: relative;
}

.separator-line.left {
  background: linear-gradient(90deg, transparent, rgba(183, 185, 186, 0.8), #8f0000);
}

.separator-line.right {
  background: linear-gradient(90deg, #8f0000, rgba(183, 185, 186, 0.8), transparent);
}

.separator-line::before {
  content: '';
  position: absolute;
  top: -4px;
  left: 10%;
  right: 10%;
  height: 10px;
  background: repeating-linear-gradient(
    90deg,
    rgba(183, 185, 186, 0.2),
    rgba(183, 185, 186, 0.2) 8px,
    transparent 8px,
    transparent 16px
  );
}

.separator-triangles {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px; /* Reduced from 60px */
  display: flex;
  justify-content: center;
  z-index: 2;
}

.triangle-left, .triangle-right {
  width: 35%; /* Reduced from 40% */
  height: 100%;
  background: linear-gradient(to bottom right, #1d1e26, transparent);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}

.triangle-right {
  background: linear-gradient(to bottom left, #1d1e26, transparent);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}

.separator-emblem {
  width: 70px; /* Reduced from 90px */
  height: 70px; /* Reduced from 90px */
  position: relative;
  margin: 0 15px;
}

.emblem-outer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid #8f0000;
  border-radius: 50%;
  animation: rotate 30s linear infinite;
  box-shadow: 0 0 15px rgba(143, 0, 0, 0.3);
}

.emblem-dot {
  position: absolute;
  width: 8px; /* Reduced from 10px */
  height: 8px; /* Reduced from 10px */
  background: rgba(183, 185, 186, 0.8);
  border-radius: 50%;
  top: calc(50% - 4px); /* Adjusted for new size */
}

.emblem-dot.left {
  left: -4px; /* Adjusted for new size */
}

.emblem-dot.right {
  right: -4px; /* Adjusted for new size */
}

.emblem-inner {
  position: absolute;
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  background: rgba(29, 30, 38, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.emblem-icon {
  width: 60%;
  height: 60%;
  background: linear-gradient(135deg, #8f0000, #690000);
  clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
  transform: rotate(45deg);
  animation: pulse 3s ease-in-out infinite;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { transform: rotate(45deg) scale(1); }
  50% { transform: rotate(45deg) scale(1.1); }
}

/* Media queries for responsiveness */
@media (max-width: 768px) {
  .section-separator {
    height: 60px;
  }
  
  .separator-line {
    width: 20%;
  }
  
  .separator-emblem {
    width: 50px;
    height: 50px;
  }
  
  .separator-triangles {
    height: 30px;
  }
}
</style>
